import { ViolationStatusesEnum } from 'APIPackage/KnmModule/enums/ViolationStatusesEnum';

export const mapViolationStatusToColor: Record<ViolationStatusesEnum, 'green' | 'red' | 'yellow'> = {
  [ViolationStatusesEnum.APPEALED]: 'green',
  [ViolationStatusesEnum.FIXED]: 'green',
  [ViolationStatusesEnum.NOT_FIXED]: 'red',
  [ViolationStatusesEnum.UNFIXABLE]: 'green',
  [ViolationStatusesEnum.APPROVING]: 'red',
  [ViolationStatusesEnum.CANCELED]: 'red',
  [ViolationStatusesEnum.SUSPENDED_BY_AGREEMENT]: 'yellow',
};
